import { ZERO_DISTANCE } from "@pdfking/math/constants"
import { MM } from "@pdfking/quantity"
import { Cross } from "@pdfking/renderer-api"

import { CROSSMARK_COLOR_ID, MEASURE_COLOR_ID, PAPER_COLOR_ID } from "../internal/data/ColorList"
import { CreatePath } from "../internal/shapes/CreatePath"
import { CreateRect } from "../internal/shapes/CreateRect"

/** One crossmark, centred on its middle along x: the stub, on paper round it
 * that hides the bleed and files beneath. */
export const CROSSMARK = [
  CreateRect(
    { x: MM(-1.5), y: MM(-0.5), width: MM(3), height: MM(1) },
    { fill_color: PAPER_COLOR_ID }
  ),
  CreatePath(
    [
      { x: MM(-1.5), y: ZERO_DISTANCE },
      { x: MM(1.5), y: ZERO_DISTANCE },
    ],
    CROSSMARK_COLOR_ID
  ),
]

/** One fold mark, centred on its middle along x: the crossmark's stub dashed,
 * two 1mm segments a 1mm gap apart, in gray. */
export const FOLDMARK = [
  CROSSMARK[0]!,
  CreatePath(
    [
      { x: MM(-1.5), y: ZERO_DISTANCE },
      { x: MM(-0.5), y: ZERO_DISTANCE },
    ],
    MEASURE_COLOR_ID
  ),
  CreatePath(
    [
      { x: MM(0.5), y: ZERO_DISTANCE },
      { x: MM(1.5), y: ZERO_DISTANCE },
    ],
    MEASURE_COLOR_ID
  ),
]

/** From the page's edge to a crossmark's middle. */
export const CROSSMARK_OFFSET = MM(4.5)
/** The room a crossmark keeps round its middle: inside the fill, clear of every
 * page. */
export const CROSSMARK_SPACE = MM(3)

/** One fold crossmark, centred on its middle: a 3mm +, in the foldmarks' gray. */
export const FOLD_CROSSMARK = Cross(MM(1.5)).map(points => CreatePath(points, MEASURE_COLOR_ID))
export const FOLD_CROSSMARK_SIZE = MM(3)

/** A foldmark's 3mm and the 1mm gap its dashes keep: the next one along. */
export const FOLDMARK_STEP = MM(4)
